import React, {useEffect, useState} from "react";
import ReactJWPlayer from 'react-jw-player';
import AppConstants from "../../Config/AppConstants";
import BoxAds from "./BoxAds";
import useWindowSize from "./UseWindowSize";

//let isPlay = false;
let removeAds = false;
let activeServer = null;
let timeoutAds;
let currentServer = null;

function Jwplayer(props) {
    const size = useWindowSize();
    let widthScreen = size.width;

    const [serverPlay, setServerPlay] = useState(null);
    const [curruntServer, setCurruntServer] = useState(0);

    window.addEventListener('blur', function () {
        if (document.activeElement === document.getElementById('iframe-in-video')) {
            onclickIframe()
        }
    });

    useEffect(() => {
        timeoutAds = setTimeout(function () {
            removeTagAds()
        }, 10000);
        return () => {
            clearTimeout(timeoutAds);
            activeServer = null;
            // isPlay = false;
        }
    }, [props.keyID]);

    const playVideo = () => {
        if (currentServer && currentServer.typePlay == 2) {
            let videoTag = document.querySelector("#funlove-video video");
            if (videoTag) {
                videoTag.play();
            }
        }

        setTimeout(function () {
            removeTagAds();
        }, 1000);

        // if (isPlay) {
        //     return false;
        // }

        // isPlay = true;
        //  console.log(props.keyID)
        //  props.onPlayVideo();
    }

    const removeTagAds = () => {
        let liquidfireTag = document.querySelector("#liquidfire");
        if (!liquidfireTag || !removeAds) {
            return false;
        }

        clearTimeout(timeoutAds);
        removeAds = false;
        liquidfireTag.remove();
    }

    const onclickIframe = async () => {
        await changeServerPlay(curruntServer);
        setTimeout(function () {
            playVideo();
        }, 1000);
    }

    const generrateAds = () => {

        removeAds = true;
        return <>
            <div className='liquidfire' id="liquidfire">
                <div onClick={() => onclickIframe()} className="outiframe">
                    {/*<BoxAds onclickIframe={onclickIframe}/>*/}
                    <iframe
                        onClick={() => onclickIframe()}
                        id="iframe-in-video"
                        src={(widthScreen <= 768) ? `/iframe.html` : `/iframepc.html`}
                        width="300"
                        height="100"
                        scrolling="no"
                        marginWidth="0"
                        marginHeight="0"
                        frameBorder="0"
                        role="none"
                        aria-label="funlove"
                    >
                    </iframe>
                </div>
            </div>
        </>
    }

    const setPlayer = () => {
        if (serverPlay.typePlay == 2) {
            return <ReactJWPlayer
                image={props.image}
                file={serverPlay.file}
                licenseKey={AppConstants.licenseKeyJwPlay}
                playerId={"funlove-video"}
                playerScript={AppConstants.playerScriptJwPlay}
            />
        }

        return <iframe
            src={serverPlay.ulr}
            frameBorder="0"
            marginWidth="0"
            scrolling="no"
            width="100%"
            height="480"
            allow="fullscreen"
            role="none Presentation"
        >
        </iframe>
    }

    const changeServerPlay = (i) => {
        activeServer = i;
        setCurruntServer(i)
        currentServer = props.sources[i];
        setServerPlay(props.sources[i]);
        return true;
    }

    let urlIframe = `<iframe width="560" height="315" src="https://funlove.info/video-iframe/${props.slug}" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;

    const copyTextInput= () => {
        var copyText = document.getElementById("share-iframe-embed");
        copyText.select();
        navigator.clipboard.writeText(copyText.value);
        return true;
    }

    return (
        <>
            {generrateAds()}
            <div id="wrapperStream">
                {!serverPlay ? <div className='defaultServer'>
                    <i className="glyphicon glyphicon-play" onClick={() => changeServerPlay(curruntServer)}></i>
                    <img src={props.image}/>
                </div> : setPlayer()}
            </div>
            <div className="player-width">
                <div className="listServer"><strong>Server:</strong>
                    {props.sources.map((item, i) => {
                        return <button
                            key={i}
                            className={i == activeServer ? 'active' : ''}
                            onClick={() => changeServerPlay(i)}
                        >
                            {item.name}
                        </button>
                    })}
                    <a href="/document.html" target="_blank"><strong>Api document here</strong></a>

                </div>
                <div className="listServer apiDocument">

                    <input
                        type="text" onClick={() => copyTextInput()}
                        id="share-iframe-embed"
                        className="share-iframe-embed" readOnly={true}
                        value={urlIframe}
                    />

                </div>
            </div>
        </>
    )
}

export default Jwplayer;
